export var AppEvents;
(function (AppEvents) {
    AppEvents["Init"] = "onInit";
    AppEvents["Run"] = "onRun";
    AppEvents["Finish"] = "onFinish";
    AppEvents["DynamicMeterFound"] = "onDynamicMeterFound";
    AppEvents["MeterLevelSet"] = "onMeterLevelSet";
    AppEvents["CampaignFound"] = "onCampaignFound";
    AppEvents["ConversationDetermined"] = "onConversationDetermined";
    AppEvents["ConversationExpired"] = "onConversationExpired";
    AppEvents["AdblockFound"] = "onAdblockFound";
    AppEvents["NotAuthorized"] = "onNotAuthorized";
    AppEvents["Authorized"] = "onAuthorized";
    AppEvents["LoggedIn"] = "onLoggedIn";
    AppEvents["HasAccess"] = "onHasAccess";
    AppEvents["HasAccessNotEntitled"] = "onHasAccessNotEntitled";
    AppEvents["HasNoActiveSubscription"] = "onHasNoActiveSubscription";
    AppEvents["AnyAccountStatusEvent"] = "onAnyAccountStatusEvent";
    AppEvents["ActionShow"] = "onActionShown";
    AppEvents["ActionClosed"] = "onActionClosed";
    AppEvents["ButtonClick"] = "onButtonClick";
    AppEvents["NewsdayButtonClick"] = "onNewsdayButtonClick";
    AppEvents["PaywallShown"] = "onPaywallShown";
    AppEvents["FlittzPaywallShown"] = "onFlittzPaywallShown";
    AppEvents["FlittzPaywallClosed"] = "onFlittzPaywallClosed";
    AppEvents["FlittzButtonClick"] = "onFlittzButtonClick";
    AppEvents["LoginShown"] = "onLoginShown";
    AppEvents["LoginClosed"] = "onLoginClosed";
    AppEvents["LoginSuccess"] = "onLoginSuccess";
    AppEvents["LoginError"] = "onLoginError";
    AppEvents["ActivationFormShown"] = "onActivationFormShown";
    AppEvents["ActivationLoginStepShown"] = "onActivationLoginStepShown";
    AppEvents["ActivationLoginStepClosed"] = "onActivationLoginStepClosed";
    AppEvents["ActivationLinkStepShown"] = "onActivationLinkStepShown";
    AppEvents["ActivationLinkStepClosed"] = "onActivationLinkStepClosed";
    AppEvents["ActivationLinkStepSubmitted"] = "onActivationLinkStepSubmitted";
    AppEvents["ActivationLinkSuccessStepShown"] = "onActivationLinkSuccessStepShown";
    AppEvents["ActivationLinkSuccessStepClosed"] = "onActivationLinkSuccessStepClosed";
    AppEvents["ActivationLinkErrorStepShown"] = "onActivationLinkErrorStepShown";
    AppEvents["ActivationLinkErrorStepClosed"] = "onActivationLinkErrorStepClosed";
    AppEvents["ActivationFormClosed"] = "onActivationFormClosed";
    AppEvents["ActivationExpiredSubscriptionStepShown"] = "onActivationExpiredSubscriptionStepShown";
    AppEvents["ActivationExpiredSubscriptionStepClosed"] = "onActivationExpiredSubscriptionStepClosed";
    AppEvents["AccessTemplateShown"] = "onAccessTemplateShown";
    AppEvents["AccessTemplateClosed"] = "onAccessTemplateClosed";
    AppEvents["AccessGranted"] = "onAccessGranted";
    AppEvents["AccessDenied"] = "onAccessDenied";
    AppEvents["LoadError"] = "onLoadError";
    AppEvents["CriticalError"] = "onCriticalError";
    AppEvents["NewsletterArrival"] = "onNewsletterArrival";
    AppEvents["ViewsAutoReset"] = "onViewsAutoReset";
    AppEvents["ActionNotFound"] = "onActionNotFound";
    AppEvents["ConversationNotFound"] = "onConversationNotFound";
    AppEvents["NewsletterUpdateResolved"] = "mg2nw_preferences_succeed_e";
    AppEvents["NewsletterSignUp"] = "onNewsletterSignUp";
    AppEvents["NewsletterSignUpFails"] = "onNewsletterSignUpFails";
    AppEvents["RegistrationShown"] = "onRegistrationShown";
    AppEvents["RegistrationError"] = "onRegistrationError";
    AppEvents["RegistrationSuccess"] = "onRegistrationSuccess";
    AppEvents["RegistrationSuccessRegister"] = "onRegistrationSuccessRegister";
    AppEvents["RegistrationSuccessLogin"] = "onRegistrationSuccessLogin";
    AppEvents["RegistrationClosed"] = "onRegistrationClosed";
    AppEvents["ResetPasswordError"] = "onResetPasswordError";
    AppEvents["ResetPasswordSuccess"] = "onResetPasswordSuccess";
    AppEvents["ABCookieSet"] = "onABCookieSet";
    AppEvents["ABCookieFail"] = "onABCookieFail";
    AppEvents["ActivationAccountCreated"] = "onActivationAccountCreated";
    AppEvents["GenericError"] = "GenericError";
    AppEvents["JsCallFired"] = "onJsCallFired";
    AppEvents["GoogleSignInChanged"] = "onGoogleSignInChanged";
    AppEvents["GoogleSignInSuccess"] = "onGoogleSignInSuccess";
    AppEvents["GoogleSignInFailure"] = "onGoogleSignInFailure";
    AppEvents["ChangedDeviceId"] = "onChangedDeviceId";
    AppEvents["NxtError"] = "onNxtError";
    //--
    AppEvents["CustomTrackedEvent"] = "nxt_customTrackedEvent";
    AppEvents["FreeArticleFired"] = "onFreeArticleFired";
    AppEvents["GiftArticleLinkGeneration"] = "onGiftArticleLinkGeneration";
    AppEvents["GiftArticleLinkValidated"] = "onGiftArticleLinkValidation";
})(AppEvents || (AppEvents = {}));
